import { connect } from 'react-refetch';
import 'isomorphic-fetch';

export const newsConnect = Component =>
  connect(() => ({
    newsFetch: '/press/api/news'
  }))(Component);

export const announcementsConnect = Component =>
  connect(() => ({
    announcementsFetch: '/press/api/announcements'
  }))(Component);

export const articlesConnect = Component =>
  connect(props => ({
    articlesFetch: `/press/api/${props.route}`
  }))(Component);

export default {
  newsConnect,
  announcementsConnect,
  articlesConnect
};



// WEBPACK FOOTER //
// ./src/pages/press/connect.js